// Em produção, o Nginx encaminha /api para o backend no domínio do cliente.
// Isso mantém HTTPS, identificação do tenant e cookies na mesma origem.
export const resolveApiBaseUrl = (environment, configuredUrl) =>
  environment === "production" ? "/api" : configuredUrl || "/api";
